import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SystemSettingsLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
`;

export const SystemSettingsTabsRow = styled.div`
  overflow-x: auto;
`;

export const SystemSettingsCanvas = styled.div`
  background: ${ColorV2.Blue7};
  border-radius: ${Radius.xl}px;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  padding: 0 ${Spacing.md}px ${Spacing.md}px;

  ${mediaMax.mobile} {
    padding: 0 ${Spacing.sm}px ${Spacing.sm}px;
  }
`;

export const SystemSettingsCard = styled.div`
  width: 100%;
  padding: ${Spacing.md}px ${Spacing.lg}px;
  border-radius: ${Radius.xl}px;
  background: ${ColorV2.White};
`;

export const SystemSettingsTabsCard = styled(SystemSettingsCard)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  box-shadow: 0 1px 2px rgba(23, 34, 77, 0.04);
`;

export const ModuleSettingsCard = styled(SystemSettingsCard)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  box-shadow: 0 1px 2px rgba(23, 34, 77, 0.04);
`;

export const ModuleSettingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.lg}px;
`;

export const ModuleSettingText = styled.div`
  min-width: 0;
`;

export const ModuleSettingTitle = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const ModuleSettingDescription = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin-top: 2px;
`;

export const ModuleSwitch = styled.button<{ $active: boolean }>`
  position: relative;
  width: 48px;
  height: 28px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 999px;
  padding: 3px;
  background: ${(props) => (props.$active ? ColorV2.Blue1 : ColorV2.Blue6)};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${ColorV2.ElectricBlue};
    outline-offset: 2px;
  }
`;

export const ModuleSwitchThumb = styled.span<{ $active: boolean }>`
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${ColorV2.White};
  transform: translateX(${(props) => (props.$active ? "20px" : "0")});
  transition: transform 0.15s ease;
`;

export const SystemSettingsCategoryContent = styled(SystemSettingsCard)`
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px rgba(23, 34, 77, 0.04);
`;

export const SystemSettingsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${Spacing.md}px;

  ${mediaMax.mobile} {
    justify-content: stretch;
  }
`;

export const SystemSettingsStatusCard = styled(SystemSettingsCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.sm}px;
  text-align: center;
`;

export const SystemSettingsStatusTitle = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const SystemSettingsStatusDescription = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;
